import {openResourceModal} from '../../core/modalCommand';
import {
	ROLE_BASED_ACCESS_CREATE_MODAL_EVENT,
	ROLE_BASED_ACCESS_DELETE_MODAL_EVENT,
	ROLE_BASED_ACCESS_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open Add Role Profile, with nothing filled in.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleBasedAccessCreateModal(command, envelope) {
	return openResourceModal(
		ROLE_BASED_ACCESS_CREATE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open Edit Role Profile for the resolved row.
 *
 * The form carries a Rules table of its own, added and edited inside it.
 * Those rules are rows within a row and are not offered here - the agent
 * opens the profile and the person works on its rules.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleBasedAccessEditModal(command, envelope) {
	return openResourceModal(
		ROLE_BASED_ACCESS_EDIT_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Delete Role Profile confirmation.
 *
 * The confirmation, not the deletion. Nothing is removed until the person
 * presses the button inside it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openRoleBasedAccessDeleteModal(command, envelope) {
	return openResourceModal(
		ROLE_BASED_ACCESS_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}
